function AccessDenied() {
    return (
      <div className="p-6 bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600">You do not have permission to access this page. Please contact an administrator if you believe this is an error.</p>
        </div>
      </div>
    );
  }
  
  export default AccessDenied;